import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import imageActionCard from './imageActionCard.js';
var schema = defineObject('imageActionCardsSection', {
    title: {
        type: 'string',
        title: 'Title',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    subtitle: {
        type: 'string',
        title: 'Subtitle'
    },
    cards: {
        type: 'array',
        title: 'Cards',
        of: [
            {
                type: 'imageActionCard'
            }
        ]
    }
}, [
    imageActionCard.schema.imageActionCard
]);
var validator = z.object({
    _type: z.literal('imageActionCardsSection'),
    title: z.string().optional(),
    subtitle: z.string().optional(),
    cards: z.array(imageActionCard.validator).optional()
});
schema.imageActionCardsSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=imageActionCardsSection.js.map